module.exports = __webpack_public_path__ + "media/images/faq/brand2-1-8fc649cf1e5449cabae5d65a283fbb40.png";